export { default as DataTable } from './DataTable';
export type { DataTableProps, ColumnConfig, SortDirection } from './types';
